<template>
  <div>
    <b-row class="align-items-center">
      <b-col cols="12">
        <b-button variant="primary" class="pull-right" @click="showModal = true">
          {{ $t('Add Team') }}
        </b-button>
      </b-col>
    </b-row>
    <create-update :show="showModal" @close="showModal = false" @onSave="getTeam" />

    <!-- Skeleton Loader -->
    <project-skeleton v-if="isLoading" :counts="3" />

    <!-- Content -->
    <div v-else>
      <b-row v-if="teams.length" class="pt-4">
        <b-col v-for="team of teams" :key="team.uuid" size="md-4" class="mt-3 col-md-4">
          <team-card :value="team" />
        </b-col>
      </b-row>

      <div v-else>
        <b-alert class="p-2 text-center" show>
          <feather-icon icon="InfoIcon" size="24" />
          <h5 class="d-inline-block ml-1">
            {{ $t('No Teams Found!') }}
          </h5>
        </b-alert>
      </div>
    </div>
  </div>
</template>
<script>
import {
  BButton, BAlert,
} from 'bootstrap-vue'
import useApollo from '@/plugins/graphql/useApollo'
import ProjectSkeleton from '@/views/common/components/ProjectSkeleton.vue'
import CreateUpdate from './update.vue'
import TeamCard from './components/teamCard.vue'

export default {
  components: {
    BButton,
    BAlert,
    CreateUpdate,
    TeamCard,
    ProjectSkeleton,
  },
  data() {
    return {
      showModal: false,
      teams: [],
      showAddTeamModel: false,
      isLoading: false,
    }
  },
  watch: {
    '$store.state.project.selectedProject': {
      handler() {
        this.getTeam()
      },
      immediate: true,
    },
  },
  methods: {
    getTeam() {
      const projectUuid = this.$store.state.project.selectedProject
      if (!projectUuid) {
        this.teams = []
        this.isLoading = false
        return
      }

      this.isLoading = true
      useApollo.team.getTeam({
        uuid: projectUuid,
      }).then(response => {
        this.teams = response.data.project.teams.data
      }).finally(() => {
        this.isLoading = false
      })
    },
  },
}
</script>
